// extracted by mini-css-extract-plugin
module.exports = {"loginItem":"styles_loginItem__2CED1","buttonBlock":"styles_buttonBlock__2hZaV","textForm":"styles_textForm__1MJI6","globalErrorMesage":"styles_globalErrorMesage__10qi7"};